const  OauthRedirect = () => import(/* webpackChunkName: "oauthRedirect" */ 'Features/oauthRedirect/Main');

export const OauthRedirectRoute = {
  name: 'oauthRedirect',
  path: 'oauthRedirect',
  component: OauthRedirect
}

